var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"user-logout v2_color_white text_underline font_size_1000rem pr-2",attrs:{"href":"#"},on:{"click":_vm.logout}},[_vm._v("Log Out")])}
var staticRenderFns = []

export { render, staticRenderFns }